// Invite-code stash — survives the auth + onboarding round trip.
//
// The consumption point (AuthedApp) mounts only AFTER sign-in and
// onboarding complete, so an invite link tapped by a signed-out or
// brand-new user must persist across: the auth redirect (web Google
// OAuth drops path+query), a signup finished in a different tab, the
// full onboarding flow, and native appUrlOpen firing while nothing is
// mounted to consume it. localStorage is the only store that spans
// all of those.

const KEY = "booda:pendingInvite";

export function stashInvite(code) {
  const cleaned = String(code || "").trim();
  if (!cleaned) return;
  try { localStorage.setItem(KEY, cleaned); } catch { /* noop */ }
}

// Read-and-clear. One consumption per stash.
export function takeInvite() {
  try {
    const code = localStorage.getItem(KEY);
    if (code) localStorage.removeItem(KEY);
    return code || null;
  } catch {
    return null;
  }
}

// Parse an invite code out of a URL (web boot + native appUrlOpen
// share one shape): ?invite=CODE or /invite/CODE.
export function inviteCodeFromUrl(url) {
  try {
    const u = new URL(url, "https://booda.app");
    const q = u.searchParams.get("invite");
    if (q) return q.trim();
    const m = u.pathname.match(/\/invite\/([A-Za-z0-9_-]+)/);
    if (m) return m[1];
  } catch { /* malformed URL */ }
  return null;
}
